(() => {
  'use strict';
  const selector = '.m-product-item[data-astro-watch-group]';
  const rank = item => Number(item.dataset.astroWatchRank || 9);
  const preferred = members => members.slice().sort((a, b) => rank(a) - rank(b) || Number(a.dataset.astroOriginalIndex) - Number(b.dataset.astroOriginalIndex));
  function collapse(items) {
    const groups = new Map();
    items.forEach(item => {
      const key = (item.dataset.astroWatchGroup || '').trim();
      if (!key) return;
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    });
    groups.forEach(members => {
      const ordered = preferred(members);
      const visible = ordered.filter(item => !item.hidden && !item.classList.contains('astro-filter-hidden'));
      const chosen = visible[0];
      ordered.forEach(item => {
        if (item !== chosen) {
          item.hidden = true;
          item.classList.add('astro-filter-hidden');
          item.style.setProperty('display', 'none', 'important');
        }
        renderSwatches(item, ordered);
      });

    });
  }
  function renderSwatches(item, members) {
    const info = item.querySelector('.m-product-card__info');
    if (!info) return;
    let row = info.querySelector('.astro-watch-swatches');
    if (row) return;
    row = document.createElement('nav');
    row.className = 'astro-watch-swatches';
    row.setAttribute('aria-label', item.closest('[data-astro-choose-color]')?.dataset.astroChooseColor || 'Choose watch color');
    members.slice(0, 3).forEach(member => {
      const link = document.createElement('a');
      const label = member.dataset.astroWatchColor;
      link.href = member.dataset.astroWatchUrl;
      link.className = 'astro-watch-swatch';
      link.title = label;
      link.setAttribute('aria-label', label);
      if (member === item) {
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'true');
      }
      const dot = document.createElement('span');
      dot.className = `astro-watch-dot astro-watch-dot--${member.dataset.astroWatchTone}`;
      dot.setAttribute('aria-hidden', 'true');
      link.append(dot);
      row.append(link);
    });

    if (members.length > 3) {
      const more = document.createElement('a');
      more.href = `${item.dataset.astroWatchUrl}#AstroWatchColors`;
      more.className = 'astro-watch-more';
      more.textContent = item.closest('[data-astro-more]')?.dataset.astroMore || '+ more';
      row.append(more);
    }

    const price = info.querySelector('.m-product-card__price');
    if (price) price.after(row); else info.append(row);
  }
  function init() {
    document.querySelectorAll('.astro-watch-colors__options').forEach(row => {
      if (row.closest('[data-astro-native-watch]')) return;
      const options = Array.from(row.querySelectorAll('.astro-watch-color'));
      options.sort((a, b) => Number(a.dataset.astroColorRank) - Number(b.dataset.astroColorRank));
      options.forEach(option => row.append(option));
      const active = row.querySelector('[aria-current="page"]');
      if (active && window.matchMedia('(max-width: 749px)').matches) {
        row.scrollLeft = Math.max(0, active.offsetLeft - (row.clientWidth - active.offsetWidth) / 2);
      }
    });
    document.querySelectorAll('[data-product-container]').forEach(container => collapse(Array.from(container.querySelectorAll(selector))));
  }
  window.AstroWatchGroups = { collapse };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

